<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">聚宝盆</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>抵押贷款</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <!-- <add-cycle @refresh="getProjectList()"></add-cycle> -->
       <router-link to="/home/cornucopia/cycle"> <el-button type="warning"  icon="el-icon-view">币种周期设置</el-button></router-link>
        <!-- <cycle-list @refresh="getProjectList()"></cycle-list> -->
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import AddCycle from './components/addCycle';
import cycleList from './components/cycleList'

export default {
  name: 'kpiProject',
  data() {
    return {
      updated: ''
    };
  },
  components: {
    List,
    Create,
    AddCycle,
    cycleList
  },
  computed: {
    ...mapState('mortgage', ['pagination', 'test', 'editingProject'])
  },
  methods: {
    ...mapActions('mortgage', [
      'getList',
      'getCoinTypeList',
      'freshData',
      'getIdamount','getCycleList'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
